import * as React from 'react';
import Avatar from '@mui/material/Avatar';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import {  ThemeProvider } from '@mui/material/styles';
import { defaultTheme } from '../App.js'
import Logo from '../components/Logo.js'
import {  signInWithEmailAndPassword  } from "firebase/auth";
import {Navigate} from 'react-router-dom';

import {getUserData} from '../controller/user.js';
import Footer from '../components/Footer.js'

export default function SignIn(props) {
    const [errorMessage,setErrorMessage] =React.useState();
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email=data.get('email').trim();
    const password=data.get('password').trim();
    console.log({
      email: data.get('email'),
      password: data.get('password'),
    });
    signInWithEmailAndPassword(props.auth, email, password)
        .then((userCredential) => {
            // Signed in 
            const userFound = userCredential.user;
            console.log("Logged ",userFound);
            getUserData(userFound)
              .then((userData) => {
                console.log("Trovato utente a db",userData);
                if (userData) userFound.db=userData;
                props.setUser(userFound);
              })
              .catch((error) => {
                
                setErrorMessage('Errore: '+error.message);
                console.error('Errore durante il recupero dei dati utente:', error);
              });
            // ...
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.error(errorMessage,errorCode);
            switch (errorCode) {
                case 'auth/invalid-login-credentials':
                    setErrorMessage('Credenziali non valide');
                    
                    break;
                
                case 'auth/invalid-email':
                    setErrorMessage('Email non valida');
                       
                      break;
                default:
                    setErrorMessage(errorMessage);
            }
        });

  };

  return (<>{(props.user) && (
    <Navigate to="/dashboard/" replace={true} />
  )}
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >{errorMessage && <Alert severity="error"> { errorMessage}</Alert>}
        
         {/* <Logo width={400} /><Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>*/}
          <Typography component="h1" variant="h5">
            Esegui l'accesso
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Indirizzo Email"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
       {/*     <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Ricordami"
            /> */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Login
            </Button>
            {/*<Grid container>
             <Grid item xs>
             *   <Link href="#" variant="body2">
                  Forgot password?
                </Link> *
              </Grid>
              <Grid item>
                <Link href="#" variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
        </Grid>*/}
          </Box>
        </Box>
        <Footer/>
      </Container>
    </>
  );
}